import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

// ----- documents -----
export const uploadDocument = async (file) => {
  const form = new FormData();
  form.append("file", file);
  const { data } = await api.post("/documents/upload", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
};
export const getDocument = async (id) => (await api.get(`/documents/${id}`)).data;
export const listDocuments = async () => (await api.get(`/documents`)).data;
export const deleteDocument = async (id) => (await api.delete(`/documents/${id}`)).data;
export const retryAnalysis = async (id, options = {}) => {
  const params = options.simple ? "?simple=true" : "";
  return (await api.post(`/documents/${id}/retry${params}`)).data;
};
export const exportPdfUrl = (id) => `${API}/documents/${id}/export.pdf`;

// ----- reminders -----
export const createReminder = async (id, email) =>
  (await api.post(`/documents/${id}/reminders`, { email })).data;
export const listReminders = async (id) => (await api.get(`/documents/${id}/reminders`)).data;
export const deleteReminder = async (subId) => (await api.delete(`/reminders/${subId}`)).data;
export const triggerRemindersNow = async () => (await api.post(`/admin/run-reminders`)).data;

// ----- auth -----
export const listRoles = async () => (await api.get("/auth/roles")).data;
export const pinLogin = async (pin, name) =>
  (await api.post("/auth/pin-login", { pin, name: name || null })).data;
export const authLogout = async () => (await api.post("/auth/logout")).data;
export const authMe = async () => (await api.get("/auth/me")).data;

// Email/password account auth
export const register = async (data) => (await api.post("/auth/register", data)).data;
export const emailLogin = async (email, password) =>
  (await api.post("/auth/login", { email, password })).data;
export const forgotPassword = async (email) =>
  (await api.post("/auth/forgot-password", { email })).data;
export const resetPassword = async (token, password) =>
  (await api.post("/auth/reset-password", { token, password })).data;

// ----- error helper -----
export const formatApiError = (e) => {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Errore generico";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x)))
      .join(" ");
  if (typeof detail.msg === "string") return detail.msg;
  return String(detail);
};
